import Vue from 'vue';
import i18n from './lang/lang';

const errorInterceptor = function(ex) {
    console.log(ex);

    var message = null;
    var statusCode = null;
    var restError = null;
    if (ex.response) {
        statusCode = ex.response.status;

        restError = {
            restStatus: statusCode,
            restCodes: []
        };
        if (ex.response.data) {
            var res = ex.response.data;
            if (res.restCodes) {
                var msg = [];
                restError.restCodes = res.restCodes;

                for (var i in res.restCodes) {
                    msg.push(i18n.t(res.restCodes[i]));
                }
                message = msg.join(", ");
            }
        } else if (ex.response.status) {
            message = i18n.t("failedWithHttpCode", {'status' : ex.response.status});
        }
    } else if (ex.request) {
        statusCode = ex.request.status;
        message = i18n.t("failedWithHttpCode", {'status' : ex.request.status + ", " + ex.request.statusText});
    } else {
        message = ex.message;
    }
    Vue.notifyError({
        title: null == statusCode ? i18n.t("requestFailed") : i18n.t("requestFailedWithStatus", {'status' : statusCode}),
        message: message
    });

    return restError ? Promise.reject(restError) : Promise.reject(ex);
};

const dev = {
    host: "http://flowrest.partheas.net",
    domain: ".partheas.net",
    authType: "cookie",
    errorInterceptor: errorInterceptor
};

const local = {
    host: "http://localhost:9999",
    domain: "localhost",
    errorInterceptor: errorInterceptor
};

const localDev = {
    host: "http://flowrest.partheas.net",
    domain: "localhost",
    errorInterceptor: errorInterceptor
};

const azhTest = {
    host: "http://10.128.8.234:9999",
    domain: "10.128.8.234",
    authType: "cookie",
    errorInterceptor: errorInterceptor
};

const azhProd = {
    host: "http://10.128.8.233:9999",
    domain: "10.128.8.233",
    authType: "cookie",
    errorInterceptor: errorInterceptor
};

const mediportTest = {
    host: "https://flowapi.mediport.dev.qarts.eu",
    domain: "mediport.dev.qarts.eu",
    authType: "cookie",
    errorInterceptor: errorInterceptor
};


const mediportProd = {
    host: "https://flowapi.mediport.partheas.net",
    domain: "mediport.partheas.net",
    authType: "cookie",
    errorInterceptor: errorInterceptor
};


// const frc = new FRC(dev);
// const frc = new FRC(local);
// const frc = new FRC(localDev);
// const frc = new FRC(azhTest);
// const frc = new FRC(azhProd);
const frc = new FRC(mediportProd);

Vue.prototype.$frc = frc;
